import React, { Component } from 'react'

class EntryButton extends Component {
  render() {
    return (
      <a
        className="waves-effect waves-light btn-large"
        href={`https://www.s-agent.jp/form/event/?id=${this.props.id || ''}`}
        target="_blank"
        rel="noopener noreferrer"
      >
        参加予約をする
      </a>
    )
  }
}

export default EntryButton